import React from 'react';

import Form from 'src/components/forms/form';
import { yup } from 'shared/core/yup';
import { USStatesMap } from 'shared/core/constants/geography';
import { StepHeader, StepPanel, StepFooter } from '../shared-components';
import { GoodCannaFooter, FormTextInput, FormSelectInput, SubmitButton } from './med-intake-ui';

// Address schema
export const addressSchema = yup.object().shape({
  streetAddress: yup.string().default('').required('Street address is required'),
  city: yup.string().default('').required('City is required'),
  state: yup.string().default('').required('State is required'),
  zipCode: yup
    .string()
    .default('')
    .required('Zip code is required')
    .matches(/^\d{5}(-?\d{4})?$/, 'Must be valid US zip code'),
  unit: yup.string().default('').optional(),
});

export type AddressFieldsType = yup.InferType<typeof addressSchema>;

type AddressStepProps = {
  onNext: (data: { address: AddressFieldsType }) => void;
  onBack: () => void;
  defaultValues?: AddressFieldsType;
};

// Get sorted list of US state names from the shared constant
const US_STATES_FULL = Object.values(USStatesMap).sort();

export const AddressStep = ({ onNext, onBack, defaultValues }: AddressStepProps): JSX.Element => {
  const handleSubmit = (data: AddressFieldsType): void => {
    onNext({ address: data });
  };

  return (
    <>
      <StepHeader
        onBack={onBack}
        showBackButton
        stepHeading='Address on your ID'
        stepDescription='Ensure the address mathches your state ID to avoid delays & discrepancies during the certification process.'
      />
      <Form onSubmit={handleSubmit} validationSchema={addressSchema} defaultValues={defaultValues}>
        <StepPanel>
          <FormTextInput name='streetAddress' label='Street Address' />
          <FormTextInput name='city' label='City' />
          <FormSelectInput name='state' id='state' label='State' defaultValue={defaultValues?.state ?? ''} mb='6px'>
            {US_STATES_FULL.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </FormSelectInput>
          <FormTextInput name='zipCode' label='Zip Code' />
          <FormTextInput name='unit' label='Unit' />
        </StepPanel>
        <StepFooter>
          <SubmitButton>Looks Good</SubmitButton>
          <GoodCannaFooter />
        </StepFooter>
      </Form>
    </>
  );
};
